// Centralized sidebar state manager for persistent OPEN / CLOSED state across route navigation
const STORAGE_KEY = "entelipro_sidebar_open";

// Default state: OPEN (true)
let isOpen = localStorage.getItem(STORAGE_KEY) !== "false";

const listeners = new Set();

export const getSidebarOpen = () => isOpen;

export const setSidebarOpen = (val) => {
  const nextVal = typeof val === "function" ? val(isOpen) : Boolean(val);
  if (nextVal !== isOpen) {
    isOpen = nextVal;
    try {
      localStorage.setItem(STORAGE_KEY, String(isOpen));
    } catch (e) {
      console.error("Failed to persist sidebar state:", e);
    }
    listeners.forEach((listener) => {
      try {
        listener(isOpen);
      } catch (e) {
        console.error("Error in sidebar state listener:", e);
      }
    });
  }
};

export const toggleSidebar = () => {
  setSidebarOpen(!isOpen);
};

export const subscribeSidebar = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
